module.exports = __webpack_public_path__ + "img/Property Location.93840418.svg";